'use client';
import React, { useState, useCallback } from 'react';
import { useEffectDidMount } from '@benzinga/hooks';
import { runningClientSide } from '@benzinga/utils';
import { PrimisURL } from '@benzinga/ads-utils';

export const LoadPrimisVideoPlayer = (id = '108449', selector?: string, src?: string) => {
  if (!runningClientSide()) {
    return;
  }

  if (document.getElementById('primis-video')) {
    return;
  }

  (function (d, s, n) {
    const placeholder = document.querySelector(selector || `#primis-${id}`);

    if (placeholder) {
      const js = d.createElement(s) as HTMLScriptElement;
      js.id = n;
      js.src = src ?? '';
      js.defer = true;
      placeholder.appendChild(js);
    }
  })(document, 'script', 'primis-video');
};

export interface PrimisProps {
  id?: string;
  selector?: string;
  renderPlaceholder?: boolean;
  placeholderId?: string;
  renderOnEvent?: boolean;
}

const RENDER_PRIMIS = 'render-primis-video';

export const Primis: React.FC<PrimisProps> = ({
  id = '108449',
  placeholderId,
  renderOnEvent = false,
  renderPlaceholder = true,
  selector,
}) => {
  const [loaded, setLoaded] = useState(false);
  const [src] = useState(PrimisURL(id));

  const load = useCallback(() => {
    LoadPrimisVideoPlayer(id, selector, src);
  }, [src, id, selector]);

  useEffectDidMount(() => {
    if (renderOnEvent) {
      window.addEventListener(RENDER_PRIMIS, () => {
        if (!loaded) {
          load();
        }
      });
    } else {
      if (loaded) {
        return;
      }
      setLoaded(true);

      if (document.readyState === 'interactive' || document.readyState === 'complete') {
        load();
      } else {
        document.addEventListener(
          'DOMContentLoaded',
          () => {
            load();
          },
          { once: true },
        );
      }
    }
  });

  const placeHolder = renderPlaceholder ? (
    <div className="primis-video" id={placeholderId || `primis-${id}`}></div>
  ) : null;

  return <>{placeHolder}</>;
};

export default Primis;
